export default "__VITE_ASSET__CGd4hPdJ__"